module.exports = __webpack_public_path__ + "static/media/bytt-no-10.d18769c1.mp3";